import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import ENUMS from '../constants/ENUMS.gen.json';
import range from 'lodash/range';
import chunk from 'lodash/chunk';

const DataApiUrl = dataApiUrl();

const Parties = () => {
  const getGroupPartiesByType = (user_group_id, type) =>
    AuthAxios.get(`${DataApiUrl}/parties`, { params: { user_group_id, type } })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getPaginatedArtistList = async () => {
    const page_size = 100;

    const { total = 0, results } = await getNextSegmentOfArtists({
      params: { type: ENUMS.PARTY_TYPE.ARTIST, page_size, page_index: 0 },
    });

    const totalPagesToRequest = Math.floor(total / page_size);
    const pagesToRequest = range(totalPagesToRequest);
    const pageResults = [...Array(totalPagesToRequest)];
    const dupeSet = new Set();
    const pageRequestChunks = chunk(pagesToRequest, 3);

    //Splitting into request
    for (let ChunkPageResponseIndexex of pageRequestChunks) {
      await Promise.all(
        ChunkPageResponseIndexex.map(async pageResponseIndex => {
          const { results } = await getNextSegmentOfArtists({
            params: { type: ENUMS.PARTY_TYPE.ARTIST, page_size, page_index: pageResponseIndex + 1 },
          });
          const dedupedResults = results.filter(artist => {
            //Need to dedupe in case order changes mid query.
            if (dupeSet.has(artist.id) === false) {
              dupeSet.add(artist.id);
              return true;
            }
            return false;
          });
          pageResults[pageResponseIndex] = results;
        })
      );
    }

    return results.concat(pageResults.flat());
  };

  const getNextSegmentOfArtists = params =>
    AuthAxios.get(`${DataApiUrl}/admin/parties`, params)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getAllByType = ({ type, search: q = null, pageSize: page_size, pageIndex: page_index }) =>
    AuthAxios.get(`${DataApiUrl}/admin/parties`, {
      params: { type, q, page_size, page_index },
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getWithReleases = id =>
    AuthAxios.get(`${DataApiUrl}/admin/parties/${id}`)
      .then(res => res.data?.data)
      .catch(err => {
        throw err.response;
      });

  const updateParty = (id, body) =>
    AuthAxios.patch(`${DataApiUrl}/admin/parties/${id}`, body)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getFromGroupWithReleasesAndTracks = user_group_id =>
    AuthAxios.get(`${DataApiUrl}/admin/parties/withTracks`, { params: { user_group_id } })
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getOrCreateAppleId = (id, forceCreateToken) =>
    AuthAxios.post(`${DataApiUrl}/admin/parties/${id}/getOrCreateAppleId`, { forceCreateToken })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  return {
    getGroupPartiesByType,
    getAllByType,
    getWithReleases,
    getFromGroupWithReleasesAndTracks,
    updateParty,
    getOrCreateAppleId,
    getPaginatedArtistList,
  };
};

export default Parties;
